import React, { Component } from "react";
import Store from "redux/store";
import ReportForm from "components/AdminComponents/ReportForm";
export default class Reporting extends Component {
  componentDidMount() {
    Store.dispatch({
      type: "SectionSelected",
      payload: "Reports",
    });
  }
  render() {
    return (
      <>
        <h4>Enter details to generate report</h4>
        <ReportForm store={false} download={true} />
      </>
    );
  }
}
